import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

//import Modal from 'shared/components/Modal';
import Modal from 'app/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import config from 'shared/config/config';
import messages, { FormattedMessage } from 'shared/messages/messages';

import {
    authorizePin
} from 'app/actions/kioskActions';

const styles = () => ({
    button: {
        float: 'left',
        width: '100%',
        marginBottom: '0.5rem',
        textAlign: 'center',
        padding: '0.3rem 1rem',
        fontSize: '1rem',
        fontWeight: 600,
        background: 'linear-gradient(#ffffff, #f1f1f1)',
        border: '1px solid #dcdcdc',
        borderRadius: '3px',
        boxShadow: '0 0 2px #dcdcdc',
        color: '#2b8eb0',
        fontFamily: config.root_font_family
    },
    label: {
        float: 'left',
        fontWeight: 600,
        fontFamily: config.root_font_family
    },
    input: {
        width: '100%',
        fontSize: '1.1rem',
        padding: '0.7655rem',
        borderRadius: '5px',
        border: '1px solid #aaa',
        fontFamily: config.root_font_family
    },
    inputGroup: {
        padding: '0.3rem 0'
    },
    ...modalStyles()
});

class AuthorizePinDialog extends React.Component {
    constructor(props) {
        super(props);

        this.pinInput = createRef();
    }

    authorizePin() {
        const { settings, authorizePin, approvedAction } = this.props;
        let pin = this.pinInput.current.value;

        return authorizePin(settings.account_id, pin).then(() => {
            if (approvedAction) {
                approvedAction();
            }
        }).catch(err => {
            console.error(err);
            throw 'Invalid pin';
        });
    }

    close() {
        this.props.onClose();
    }

    renderPinSlide() {
        const { classes } = this.props;

        let slide = {};

        slide.component = (
            <div>
                <div className={classes.modalHeader}>
                    <span style={{ fontWeight: 600 }}>Enter PIN</span>
                </div>
                <hr />
                <div className={classes.inputGroup}>
                    <label className={classes.label} style={{ marginBottom: '0.2rem' }} for="room">
                        PIN
                    </label>
                    <input ref={this.pinInput} className={classes.input} type="password" name="pin" style={{ borderColor: '#aaa' }} />
                </div>
            </div>
        );

        slide.nextLabel = <FormattedMessage {...messages.button_approve} />;
        slide.onNext = () => this.authorizePin();
        slide.prevLabel = <FormattedMessage {...messages.button_back} />;

        return slide;
    }

    render() {
        let slides = [];
        slides.push(this.renderPinSlide());
        return <Modal slides={slides} open={this.props.open} onClose={() => this.close()} />;
    }
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings
});

export default connect(mapStateToProps, { authorizePin })(withStyles(styles)(AuthorizePinDialog));
